import { cn, cva, IconSize, NoddiIcon, type VariantProps } from 'noddi-ui-common';
import React from 'react';

const spinnerVariants = cva('flex-col items-center justify-center', {
  variants: {
    show: {
      true: 'flex',
      false: 'hidden'
    }
  },
  defaultVariants: {
    show: true
  }
});

interface SpinnerContentProps extends VariantProps<typeof spinnerVariants> {
  className?: string;
  children?: React.ReactNode;
  size?: IconSize;
  color?: string;
}

export function NoddiSpinner({ size = 'medium', show, children, className, color }: SpinnerContentProps) {
  return (
    <span className={cn(spinnerVariants({ show }), 'text-primary', className)}>
      <div className='animate-spin'>
        {/* Dont add default color here, as this will break styling color with className*/}
        <NoddiIcon color={color} name='Loader2' size={size} />
      </div>
      <div className='text-black'>{children}</div>
    </span>
  );
}
